export default "__VITE_ASSET__BMvnqA$K__"